<template>
  <div>
    <h1 class="title-page">
      <v-icon class="material-icons-outlined">import_contacts</v-icon>
      <br />連絡帳を製本
    </h1>

    <v-card class="card">
      <Overview
        @show-product-detail-full-screen-dialog="
          $emit('show-product-detail-full-screen-dialog')
        "
      />

      <h2 class="title-bar">お子さまを選択（{{ familyName }}）</h2>
      <section>
        <v-radio-group
          :value="selectedKid"
          :label="organizationName"
          @change="$emit('update:selectedKid', $event)"
        >
          <v-radio
            v-for="kid in kids"
            :key="kid.id"
            :label="kid.name"
            :value="kid"
          >
          </v-radio>
        </v-radio-group>
        <p class="sub-text">
          【購入期間について】<br />
          卒園・退園されたお子さまの連絡帳製本もご購入いただけます。<br />
          2027年3月31日までは、過去に在籍していた全ての期間の製本が購入可能です。それ以降は卒園・退園年度の翌年度の3月末まで購入可能となります。
        </p>

        <v-layout justify-center column pb-4 align-center>
          <v-btn
            class="v-btn--minwidth"
            color="primary"
            :disabled="!selectedKid"
            @click="$emit('next')"
          >
            次へ進む
          </v-btn>

          <v-btn
            class="v-btn--minwidth"
            color="negative"
            :to="{ name: 'organizationTop', params: { organizationId } }"
          >
            園トップページへ
          </v-btn>
          <router-link :to="{ name: 'organizations' }" class="mt-3">
            園・施設の切り替え ≫
          </router-link>
        </v-layout>
      </section>
    </v-card>
  </div>
</template>

<script>
import { Kid } from '../../../../models/CombookBinding';
import { PropType } from 'vue';
import Overview from '../Overview.vue';

export default {
  name: "SelectKid",
  components: {
    Overview
  },
  props: {
    familyName: {
      type: String,
      default: null
    },
    organizationId: {
      type: Number,
      required: true
    },
    organizationName: {
      type: String,
      default: null
    },
    kids: {
      type: Array as PropType<Kid[]>,
      default: () => []
    },
    selectedKid: {
      type: Object as PropType<Kid>,
      default: null
    }
  }
};
</script>

<style scoped>
.card {
  max-width: 443px;
}
.card section {
  padding: 16px;
}
.title-bar {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sub-text {
  font-size: 12px;
  color: #545454;
}
</style>
